module.exports = __webpack_public_path__ + "static/Kakilang_menu_large-26d433b85db4e37a1c4b06efbbdb7ffe.jpg";